var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1433 5.83333H9.16667C7.84058 5.83333 6.56882 6.36012 5.63113 7.2978C4.69345 8.23548 4.16667 9.50725 4.16667 10.8333C4.16667 12.1594 4.69345 13.4312 5.63113 14.3689C6.56882 15.3066 7.84058 15.8333 9.16667 15.8333H15.8333C16.2936 15.8333 16.6667 16.2064 16.6667 16.6667C16.6667 17.1269 16.2936 17.5 15.8333 17.5H9.16667C7.39856 17.5 5.70286 16.7976 4.45262 15.5474C3.20238 14.2971 2.5 12.6014 2.5 10.8333C2.5 9.06522 3.20238 7.36953 4.45262 6.11929C5.70286 4.86905 7.39856 4.16667 9.16667 4.16667H15.1433L13.6192 2.6425C13.2938 2.31711 13.2938 1.78955 13.6192 1.46417C13.9446 1.13878 14.4721 1.13878 14.7975 1.46417L18.3333 5L14.7975 8.53583C14.4721 8.86122 13.9446 8.86122 13.6192 8.53583C13.2938 8.21045 13.2938 7.68289 13.6192 7.3575L15.1433 5.83333Z",
    fill: "#2C304B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.fd616453ee35cee8d9f8d797bcce7e6f.svg";
export { ForwardRef as ReactComponent };